import { Clock, Radio, ShieldCheck, Newspaper, BarChart2, ListChecks, CheckCircle2 } from 'lucide-react';

export default function BriefThemeBar({ session = 'pre', date, headline, accent, issueNum, stockCount, sectionCount, confidence }) {
  const bspCls = session === 'live' ? 'bsp bsp-live' : 'bsp bsp-pre';
  const SessionIcon = session === 'live' ? Radio : Clock;
  const sessionLabel = session === 'live' ? 'Live' : 'Pre-Market';

  return (
    <div className="brief-theme-bar">
      <div className="brief-theme-meta">
        <span className={bspCls}>
          <SessionIcon size={10} /> {sessionLabel}
        </span>
        <span>{date}</span>
        {confidence && (
          <span className="brief-conf">
            <ShieldCheck size={11} /> {confidence}% Verified
          </span>
        )}
      </div>
      <div className="brief-theme-headline">
        {headline}{accent && <> <em>{accent}</em></>}
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 16, fontFamily: 'var(--fm)', fontSize: 11, color: 'var(--muted)' }}>
        {issueNum && <span><Newspaper size={11} style={{ verticalAlign: 'middle' }} /> Issue #{issueNum}</span>}
        {stockCount && <span><BarChart2 size={11} style={{ verticalAlign: 'middle' }} /> {stockCount} stocks in focus</span>}
        {sectionCount && <span><ListChecks size={11} style={{ verticalAlign: 'middle' }} /> {sectionCount} sections</span>}
        <span style={{ color: 'var(--green)' }}>
          <CheckCircle2 size={11} style={{ verticalAlign: 'middle' }} /> Fact vs. Inference framework active
        </span>
      </div>
    </div>
  );
}
